import { Observable, forkJoin } from "rxjs";
import { CommonService } from "./common.service";
import { Resolve } from "@angular/router";
import { Injectable } from "@angular/core";


@Injectable()
export class ConfigResolverService implements Resolve<Observable<any>> {

  constructor(private commonService: CommonService) { }

  resolve(): Observable<any> {
    return new Observable((obs) => {
        const obsArr: any = [];
        obsArr.push(this.commonService.fetchMiscConfig());
        obsArr.push(this.commonService.fetchWorkflowConfig());
        forkJoin(obsArr).subscribe(() => {
            obs.next(true);
        }, () => {
            obs.next(true);
        }, () => {
            this.commonService.setLoadingFalse();
            obs.complete();
        });
    });
  }
}
